import { createSlice } from '@reduxjs/toolkit';
import { createApprovalFlow, getApprovalFlow } from '../api/approval';

interface UsersState {
  loading: boolean;
  currentRequestId: undefined | string;
  userData: any;
  error: any;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  userData: null,
  error: null,
} as UsersState;

export const approvalFlowSlice = createSlice({
  name: 'createApprovalFlow',
  initialState,
  reducers: {
    resetapprovalFlow: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(createApprovalFlow.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(createApprovalFlow.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(createApprovalFlow.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
          state.error = action.error;
        }
      })
      .addCase(getApprovalFlow.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getApprovalFlow.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(getApprovalFlow.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
          state.error = action.error;
        }
      });
  },
});

export const { resetapprovalFlow } = approvalFlowSlice.actions;

export default approvalFlowSlice.reducer;
